import React from 'react';
import { SitemapView } from './sitemap-view';
import { useGlobalState } from '../global/context/global-context';
import { BaseLayoutFactory } from '../global/base-layout-factory';

export const SitemapFactory: React.FC = () => {
  const { applicationData } = useGlobalState();

  return (
    <BaseLayoutFactory>
      <SitemapView
        entityName={applicationData?.entity?.nickName}
        menus={applicationData?.menus || []}
      />
    </BaseLayoutFactory>
  );
};
